<template>
    <v-menu
        v-if="variant"
        v-model="menu"
        :close-on-content-click="false"

        :left="true"
        :nudge-bottom="10"
        transition="slide-x-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <span class="zero-note" v-bind="attrs" v-on="on">{{ dateFormatted }}</span>
        </template>
        <v-date-picker
            v-model="date"
            type="month"
            no-title
            locale="ru"
            first-day-of-week="1"
            @input="menu = false"
        ></v-date-picker>
    </v-menu>
    <v-menu
        v-else
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :label="label"
                v-model="dateFormatted"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            type="month"
            no-title
            locale="ru"
            first-day-of-week="1"
            @input="menu = false"
        ></v-date-picker>
    </v-menu>
</template>

<script>
import moment from "moment";

export default {
    props: {
        value: {},
        label: {
            default: 'Выберите месяц'
        },
        variant: {
            default: false,
        },
    },
    data: function () {
        return {
            date: '',
            dateFormatted: '',
            menu: false
        }
    },
    mounted: function () {
        this.date = this.value ? this.value : moment().format('YYYY-MM');
    },
    watch: {
        date(val) {
            this.dateFormatted = this.formatDate(val);
            this.$emit('input', val);
            this.$emit('change', val);
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return null;
            return moment(date).locale('ru').format('MMMM YYYY');
        },
    }
}
</script>

<style scoped lang="scss">
.calendar {
    background: url('/svg/calendar.svg') no-repeat center;
    width: 17px;
    height: 21px;
    background-size: 18px 19px;
}

.error--text div.calendar {
    background-image: url('/svg/calendar_red.svg');
}

.zero-note {
    display: flex;
    cursor: pointer;
    font-family: 'SFPro', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #6b7a72;
    background: #eaf5ee;
    border-radius: 20px;
    padding: 6px 16px;
    margin-left: 4px;
    transition: all 0.25s ease;

    &:hover {
        background: #dde5df;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
        transform: translateY(-2px);
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/fields/Month.vue